import { render } from "./ModalDocumentosProduto.vue?vue&type=template&id=a4c9762c"
import script from "./ModalDocumentosProduto.vue?vue&type=script&lang=js"
export * from "./ModalDocumentosProduto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__